var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isUiMinimized && _vm.isBottomBtnShow
    ? _c(
        "v-toolbar",
        _vm._g(
          {
            class: { minimized: _vm.isUiMinimized },
            attrs: {
              id: "headbar",
              color: _vm.toolbarColor,
              app: "",
              flat: "",
              fixed: "",
              dense: this.$store.state.isRunningEmbedded && !_vm.isUiMinimized,
              "aria-label":
                "Toolbar with sound FX mute button, minimise chat window button and option chat back a step button"
            }
          },
          _vm.toolbarClickHandler
        ),
        [
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  return _vm.returnTop()
                }
              }
            },
            [
              _c("img", {
                staticStyle: { display: "flex" },
                attrs: {
                  src: require("@/assets/arrow-left@2x.png"),
                  width: "30vw",
                  height: "30vw"
                }
              })
            ]
          ),
          _vm.showToolbarMenu
            ? _c(
                "v-menu",
                { attrs: { "offset-y": "" } },
                [
                  _c(
                    "v-list",
                    [
                      _vm.isForceLogin
                        ? _c(
                            "v-list-tile",
                            [
                              _vm.isLoggedIn
                                ? _c(
                                    "v-list-tile-title",
                                    {
                                      attrs: { "aria-label": "logout" },
                                      on: { click: _vm.requestLogout }
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          " " + _vm._s(_vm.items[1].icon) + " "
                                        )
                                      ]),
                                      _vm._v(
                                        " " + _vm._s(_vm.items[1].title) + " "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.isLoggedIn
                                ? _c(
                                    "v-list-tile-title",
                                    {
                                      attrs: { "aria-label": "login" },
                                      on: { click: _vm.requestLogin }
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          " " + _vm._s(_vm.items[0].icon) + " "
                                        )
                                      ]),
                                      _vm._v(
                                        " " + _vm._s(_vm.items[0].title) + " "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-title",
                            {
                              attrs: { "aria-label": "clear chat history" },
                              on: { click: _vm.requestResetHistory }
                            },
                            [
                              _c("v-icon", [
                                _vm._v(" " + _vm._s(_vm.items[2].icon) + " ")
                              ]),
                              _vm._v(" " + _vm._s(_vm.items[2].title) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.shouldRenderSfxButton && _vm.isSFXOn
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-title",
                                {
                                  attrs: { "aria-label": "mute sound effects" },
                                  on: { click: _vm.toggleSFXMute }
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      " " + _vm._s(_vm.items[3].icon) + " "
                                    )
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.items[3].title) + " ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.shouldRenderSfxButton && !_vm.isSFXOn
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-title",
                                {
                                  attrs: {
                                    "aria-label": "unmute sound effects"
                                  },
                                  on: { click: _vm.toggleSFXMute }
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      " " + _vm._s(_vm.items[4].icon) + " "
                                    )
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.items[4].title) + " ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-title",
                            {
                              attrs: { "aria-label": "request live chat" },
                              on: { click: _vm.requestLiveChat }
                            },
                            [
                              _c("v-icon", [
                                _vm._v(" " + _vm._s(_vm.items[5].icon) + " ")
                              ]),
                              _vm._v(" " + _vm._s(_vm.items[5].title) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-title",
                            {
                              attrs: { "aria-label": "end live chat" },
                              on: { click: _vm.endLiveChat }
                            },
                            [
                              _c("v-icon", [
                                _vm._v(" " + _vm._s(_vm.items[6].icon) + " ")
                              ]),
                              _vm._v(" " + _vm._s(_vm.items[6].title) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.locales, function(locale) {
                        return _c(
                          "v-list-tile",
                          {
                            key: locale,
                            attrs: { disabled: _vm.restrictLocaleChanges }
                          },
                          [
                            _c(
                              "v-list-tile-title",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.setLocale(locale)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(locale) + " ")]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "nav-buttons" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    activator: ".nav-button-prev",
                    "content-class": "tooltip-custom",
                    right: ""
                  },
                  model: {
                    value: _vm.prevNav,
                    callback: function($$v) {
                      _vm.prevNav = $$v
                    },
                    expression: "prevNav"
                  }
                },
                [_c("span", [_vm._v("Previous")])]
              )
            ],
            1
          ),
          _c(
            "v-toolbar-title",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isUiMinimized,
                  expression: "!isUiMinimized"
                }
              ],
              staticClass: "hidden-xs-and-down",
              style: { display: "flex" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleMinimize($event)
                }
              }
            },
            [
              _vm.toolbarLogo
                ? _c("img", {
                    style: {
                      width: "7vw",
                      height: "7vw"
                    },
                    attrs: { src: _vm.toolbarLogo }
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "1.5vw",
                    color: "#333333",
                    fontsize: "1.3rem",
                    "font-weight": "700",
                    "margin-top": "1vw",
                    "font-size": "5vw"
                  },
                  on: { click: _vm.onClickTitle }
                },
                [_vm._v(" " + _vm._s(_vm.$t("licence.Robot_title_Beta")) + " ")]
              )
            ]
          ),
          _c(
            "v-toolbar-title",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isUiMinimized,
                  expression: "!isUiMinimized"
                }
              ],
              staticClass: "hidden-xs-and-down"
            },
            [_vm._v(" " + _vm._s(_vm.userName) + " ")]
          ),
          _c("v-spacer"),
          _c(
            "v-tooltip",
            {
              attrs: {
                "content-class": "tooltip-custom",
                activator: ".min-max-toggle",
                left: ""
              },
              model: {
                value: _vm.shouldShowTooltip,
                callback: function($$v) {
                  _vm.shouldShowTooltip = $$v
                },
                expression: "shouldShowTooltip"
              }
            },
            [
              _c("span", { attrs: { id: "min-max-tooltip" } }, [
                _vm._v(_vm._s(_vm.toolTipMinimize))
              ])
            ]
          ),
          _c(
            "v-tooltip",
            {
              attrs: {
                "content-class": "tooltip-custom",
                activator: ".help-toggle",
                left: ""
              },
              model: {
                value: _vm.shouldShowHelpTooltip,
                callback: function($$v) {
                  _vm.shouldShowHelpTooltip = $$v
                },
                expression: "shouldShowHelpTooltip"
              }
            },
            [_c("span", { attrs: { id: "help-tooltip" } }, [_vm._v("help")])]
          ),
          _c(
            "v-tooltip",
            {
              attrs: {
                "content-class": "tooltip-custom",
                activator: ".menu",
                right: ""
              },
              model: {
                value: _vm.shouldShowMenuTooltip,
                callback: function($$v) {
                  _vm.shouldShowMenuTooltip = $$v
                },
                expression: "shouldShowMenuTooltip"
              }
            },
            [_c("span", { attrs: { id: "menu-tooltip" } }, [_vm._v("menu")])]
          ),
          _c("div", { on: { click: _vm.sendHelp } }, [
            _c("img", {
              style: {},
              attrs: { src: _vm.icondotsLogo, width: "28vw", height: "28vw" }
            })
          ]),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.sheet,
                callback: function($$v) {
                  _vm.sheet = $$v
                },
                expression: "sheet"
              }
            },
            [
              _c(
                "v-card",
                { style: { "border-radius": "15px" } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "titleText",
                      staticStyle: { "padding-bottom": "0" }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("licence.key_delete_confirmation"))
                      )
                    ]
                  ),
                  _c("v-card-title", { staticClass: "text-h5" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("licence.key_delete_popup")) + " "
                    )
                  ]),
                  _c("v-divider", {
                    style: {
                      backgroundColor: "#eeeeee"
                    }
                  }),
                  _c(
                    "v-card-actions",
                    {
                      style: {
                        "justify-content": "space-around",
                        padding: "15px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            width: "-webkit-fill-available",
                            "justify-content": "space-evenly"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "4.5vw",
                                "font-weight": "bold"
                              },
                              attrs: { white: "", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.sheet = _vm.dialog = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("licence.key_cancel")) + " "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticStyle: { color: "#eeee", width: "1vw" } },
                            [_vm._v("|")]
                          ),
                          _c(
                            "div",
                            {
                              style: {
                                color: "#0A79C3",
                                fontSize: "4.5vw",
                                "font-weight": "bold"
                              },
                              attrs: { text: "" },
                              on: { click: _vm.requestResetHistory }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("licence.key_confirm")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.$store.state.isRunningEmbedded
            ? _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "min-max-toggle",
                    attrs: {
                      icon: "",
                      "aria-label": _vm.isUiMinimized
                        ? "chat"
                        : "minimize chat window toggle"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggleMinimize($event)
                      }
                    }
                  },
                  _vm.tooltipEventHandlers
                ),
                [
                  _c("v-icon", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.isUiMinimized ? "chat" : "arrow_drop_down") +
                        " "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-bottom-sheet",
            {
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { staticClass: "bottomsheet" }, [
                _c(
                  "div",
                  { staticClass: "text-center", attrs: { height: "200px" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "py-3",
                        on: {
                          click: function($event) {
                            _vm.sheet = true
                          }
                        }
                      },
                      [
                        _c("v-divider", {
                          style: {
                            width: "46px",
                            height: "4px",
                            "border-radius": "3px",
                            marginLeft: "43vw",
                            "margin-bottom": "6vw",
                            backgroundColor: "#C1C1C1"
                          },
                          attrs: { inset: "" }
                        }),
                        _c("div", { staticClass: "bottomContainer" }, [
                          _c("div", { staticClass: "deleteIcon" }, [
                            _c("img", {
                              style: { "margin-top": "2.5vw" },
                              attrs: {
                                src: require("../assets/delete@2x.png"),
                                width: "22vw",
                                height: "22vw"
                              }
                            })
                          ]),
                          _c("div", { staticClass: "bottomFont" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("licence.key_delete_history")) +
                                " "
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }